<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

 <v-spacer></v-spacer>
        <material-card
            :color="app.color"            
          >
          <v-container></v-container>
         <v-layout wrap slot="header">
        <v-flex sm6 xs12
        >
          <span class="title">Contracten</span><br> 
          <span class="body-1">{{user.organisation.name}}</span> 
        </v-flex>

        </v-layout>

          <v-container fluid class="pa-3">
            <v-layout row>

              <v-spacer></v-spacer>

              <!-- show details -->
              <v-flex class="text-sm-right">

                <v-tooltip bottom dark v-if="showTemplates == false">
                    <template #activator='data'>
                      <v-btn large text="" icon="" color="transparent">
                        <v-icon medium @click="showTemplates = true"  color="success" v-on="data.on">mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Nieuwe overeenkomst</span>
                </v-tooltip>     
                
                <v-tooltip bottom dark v-if="showTemplates == true">
                    <template #activator='data'>
                      <v-btn large text="" icon="" color="transparent">
                        <v-icon medium @click="showTemplates = false"  color="error" v-on="data.on">mdi-minus</v-icon>
                      </v-btn>
                    </template>
                    <span>Sluiten</span>
                </v-tooltip>     
              <!-- </div>   -->
              </v-flex>
            </v-layout>
          </v-container>

          <v-expand-transition>
            <v-container fluid v-if="showTemplates == true" class="pa-5">
              <div v-if="user.organisation.generic_templates == true && containsCustomTemplate && containsGenericTemplate">
                <v-layout row justify-center="">
                  <p class="headline">{{user.organisation.name}}</p>
                </v-layout>
                  <v-divider></v-divider>
                  <br>
              </div>
              <v-layout wrap justify-center="">
                <div v-for="(item, i) in templates" :key="i">
                <v-flex v-if="!item.generic" class="expansion">
                    <templates-template-card :item="item" source="contracts"></templates-template-card>
                </v-flex>
                </div>
              </v-layout>
              <div v-if="user.organisation.generic_templates == true && containsCustomTemplate && containsGenericTemplate">              
                <br>
                <v-layout row justify-center="">
                  <p class="headline">Algemene modellen</p>
                </v-layout>
                  <v-divider></v-divider>
                  <br>
              </div>

              <v-layout wrap justify-center="">
                <div v-for="(item, i) in templates" :key="i">
                <v-flex v-if="item.generic" class="expansion">
                    <templates-template-card :item="item" source="contracts"></templates-template-card>
                </v-flex>
                </div>
              </v-layout>
            </v-container>
          </v-expand-transition>


          <v-data-table
              :sort-by="['created_date']"
              :sort-desc="[true]"
              :headers="headers"
              :items="contracts"
              :search="search"
              :loading="loading"   
              :footer-props="{
                itemsPerPageText: ''
              }">

              <template v-slot:no-data>

                <v-layout v-if="loading" row justify-center="" class="pa-4">
                  Contracten ophalen
                </v-layout>
                
                <v-layout v-if="!loading" row justify-center="" class="pa-4">
                  Geen contracten gevonden
                </v-layout>

              </template>

              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>

              <template
                v-slot:item="props"
              >
              <v-slide-x-transition>
                
                <tr class="selectorRow">

                  <td>
                    <v-tooltip right="" dark>
                      <template #activator='data'>
                        <v-avatar v-on="data.on" size="32" :color="props.item.status.color" small>
                          <span class="white--text">{{props.item.created_by.initials}}</span>
                        </v-avatar>
                      </template>
                      <span class="caption">{{props.item.created_date | created}}</span><br>
                      <span class="caption">{{props.item.created_by.full_name}}</span><br>
                      <span class="caption">{{props.item.status.title}}</span>
                      

                    </v-tooltip>
                  </td>
                  <!-- <td>
                    <span class="party" v-if="props.item.parent != object.reference">{{props.item.parent.title}}</span>
                  </td> -->
                  <td @click="toContract(props.item.reference)">
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.parent !== null">{{props.item.parent.descriptor}} : {{props.item.parent.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.parent == null">Geen partijen geselecteerd</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_1 !== null">{{props.item.party_1.descriptor}} : {{props.item.party_1.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_2 !== null">{{props.item.party_2.descriptor}} : {{props.item.party_2.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_3 !== null">{{props.item.party_3.descriptor}} : {{props.item.party_3.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_4 !== null">{{props.item.party_4.descriptor}} : {{props.item.party_4.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_5 !== null">{{props.item.party_5.descriptor}} : {{props.item.party_5.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_6 !== null">{{props.item.party_6.descriptor}} : {{props.item.party_6.title}}</p>
                  </td>
                  <td @click="toContract(props.item.reference)">
                    <span>{{props.item.template.name}}</span><br>
                    <span class="caption">{{props.item.template.subtitle}}</span>
                  </td>

                  <!-- <td v-if="props.item.duration != null" @click="toContract(props.item.reference)">{{props.item.duration.title}}</td> -->
                  <!-- <td v-if="props.item.duration == null" @click="toContract(props.item.reference)" ></td> -->
                  <td @click="toContract(props.item.reference)" >
                    <v-chip small outlined :color="props.item.expiration_status">{{props.item.time_to_expire}}</v-chip>
                  </td>
                  <td>
                      <v-layout>
                        <v-icon @click="showArchiveDialog({type:'contract',description:props.item.template.name, reference:props.item.reference})" size="22" id="delete">mdi-delete</v-icon>
                      </v-layout>
                    </td>
                </tr>
              </v-slide-x-transition>

              
              </template>
  
            </v-data-table>

        </material-card>
      </v-flex>

    </v-layout>

    <dialog-delete></dialog-delete>



  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment, { months } from "moment";

export default {
  filters: {
    moment(date) {
      moment.locale("nl");
      if (date != null) {
        return moment(date).format("LL");
      } else {
        return "N/A";
      }
    },
    created(date) {
      moment.locale("nl");
      return moment(date).format("LLL");
    },
    expiration_date(exp_date) {
      moment.locale("nl");

      var now = moment(now);
      var expiration = moment(exp_date);
      var delta = moment.duration(expiration.diff(now)).humanize(true);

      return delta;
    }
  },
  data: () => ({
    showTemplates: false,
    search: "",
    showDetails: false,
    showTemplates: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10 // -1 for All
    },
    headers: [
      {
        sortable: false,
        text: "",
        value: "created_by.full_name"
      },
      {
        sortable: true,
        text: "Partijen",
        value: "title"
      },
      {
        sortable: true,
        text: "Model",
        value: "title"
      },

      {
        sortable: true,
        text: "Resterende looptijd",
        value: "time_to_expire"
      }

      // {
      //   sortable: true,
      //   text: "Periode tot verlenging",
      //   value: "extention_date"
      // },
      // {
      //   sortable: true,
      //   text: "Periode tot indexering",
      //   value: "expiration_date"
      // }
    ]
  }),
  computed: {
    ...mapState(["object", "app", "user", "contracts", "templates"]),
    ...mapState(["app"]),
    loading() {
      return this.app.contracts.loading;
    },
    containsCustomTemplate() {
      var results = this.$store.state.templates.filter(
        item => item.generic == false
      );
      //console.log("length", results.length);
      if (results.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    containsGenericTemplate() {
      var results = this.$store.state.templates.filter(
        item => item.generic == true
      );
      //console.log("length", results.length);
      if (results.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(["updateObject", "resetObject", "toObjects"]),
    ...mapMutations(["showArchiveDialog"]),
    toContract(reference) {
      this.$store.dispatch("toContract", {
        reference: reference
      });
    }
  },
  mounted() {
    this.$store.dispatch("checkAuth");
    this.$store.state.object = {};
    this.$store.dispatch("getAllContracts");
    this.$store.dispatch("getAllTemplates");
  },
  beforeDestroy() {
    this.$store.state.app.dossier.show = false;
  }
};
</script>

<style scoped>
.party {
  /* font-style: bold; */
  text-overflow: ellipsis;
  font-size: 12.5px !important;
}

#panel {
  padding: 40px 20px 20px 20px;
}

.expansion {
  margin: 15px;
  max-width: 260px;
  min-width: 260px;
  height: 260px;
  min-height: 100%;
}

#delete {
  color: grey;
}
#delete:hover {
  color: #d3223c;
}
</style>
